

import React from 'react';
import { connect } from 'react-redux';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import { setCache,setRegisterDetails } from '../../General/Actions.js';
import Network from '../../Utils/network.js';
import Swal from 'sweetalert2';
import moment from 'moment';
import { FaPlus, FaMinus } from 'react-icons/fa';
import NoDataFound from '../../Utils/noDataFound.js';
import GeneralUtils from '../../Utils/generalUtils.js';
import PlanCartComponent from './Components/ActivateAddonCartComponent.js';
import { Button } from 'reactstrap';
import PathIcon from '../../ImageAssets/pathIcon.png';
import Constants from '../../Utils/constants.json';
import AddonConfirmationPart from './Components/AddonConfirmationComponent.js'

class RechargeComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            billingName: "",
            contactNumber: "",
            accountId:"",
            currentActiveSubMenu: "OVERVIEW",
            isFloatingSubMenuVisible: false,
            addonArray: [],
            ignorePlanIds: [],
            customizeDetails: {
                devices: [],
                addons: [],
                returnDevice: [],
                showCustomizeButton: false
            },
            activeAddonIds: [],
            isCartVisibleForMobile: false,
            allAddonDetails: [],
            totalMonthlyCharges: 0,
            isConfirmationPageVisible: false
        }
    }

    componentDidMount() {
        this.props.setRegisterDetails("generalResponse.type","addAddon")
        this.props.setRegisterDetails("isConfirmationReached", false);
        this.getAllAddonIds();
        var dataToSend = {
            "serviceId": this.props.cache.serviceInfo.serviceId,
            "actionType": "add_on_add"
        }

        Network.executeAxios("eligibilityValidation", "POST", dataToSend, (validationResponse) => {
            if (validationResponse && validationResponse.BillingSystem && validationResponse.BillingSystem.response
                && validationResponse.BillingSystem.response.optionlist[0] && validationResponse.BillingSystem.response.optionlist[0].response_code) {
                var resultCode = validationResponse.BillingSystem.response.optionlist[0].response_code;
                var resultDesc = validationResponse.BillingSystem.response.optionlist[0].response_description
                if (resultCode === "0") {
                    Network.executeAxios("fetchIgnorePlanDetails", "POST", dataToSend, (ignoredPlanResponse) => {
                        var ignoredPlanArr = []
                        if(ignoredPlanResponse && ignoredPlanResponse[0]){
                            for(var h=0; h< ignoredPlanResponse.length; h++){
                                ignoredPlanArr.push(ignoredPlanResponse[h].PLAN_NAME)
                            }
                        }
                
                        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                        //this.props.setRegisterDetails("customize.addons", []);
                        this.fetchAddonsFromUpc(ignoredPlanArr);
                    })
                } else {
                    this.setState({ isLoading: false })
                    Swal.fire(resultDesc, "", "");

                }
           
            } else {
                this.setState({ isLoading: false })
                Swal.fire(this.props.locales.LoginPageUnableToProcessSwal, "", "");
            }
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.registerDetails !== prevProps.registerDetails) {
            this.calculateTotalCharge();
        }
    }
    calculateTotalCharge() {
        let sum = 0;
        for (var i = 0; i < this.props.registerDetails.customize.addons.length; i++) {
            var currentObj=this.props.registerDetails.customize.addons[i];
            sum = sum + (parseFloat(currentObj.offerAmount || 0) * currentObj.count)
            for(var k=0; k < currentObj.taxArray.length; k++){
                sum = sum + parseFloat(currentObj.taxArray[k].taxPrice)
            }
            for(var j=0; j < currentObj.discountArray.length; j++){
                sum = sum - parseFloat(currentObj.discountArray[j].discountPrice)
            }
        }

        this.state.totalMonthlyCharges = sum;
        //this.props.setRegisterDetails("generalResponse.amountToPay",sum)
        this.setState({ dummy: "dummy" });
    }


    getAllAddonIds(){
        var activeAddonIds = [];
        for(var i=0;i<this.props.registerDetails.activeAddons.length; i++){
            activeAddonIds.push(this.props.registerDetails.activeAddons[i].planId)
        }
        this.setState({activeAddonIds: activeAddonIds})
    }

    arrowButtonClicked(type){
        this.setState({isCartVisibleForMobile:type})
    }

    fetchAddonsFromUpc(ignoredPlanArr){
        var headers = {};
        headers["CustomerType"] = this.props.userDetails.customerType;
        headers["CustomerCategory"] = this.props.userDetails.customerCategory;
        headers["CustomerSubCategory"] = this.props.userDetails.customerSubCategory;
        headers["Channel"] = this.props.locales.channelIdForSCM;
        headers["CONNECTIONTYPE"] = this.props.cache.serviceInfo.connectionType;

        window.addEventListener('resize', this.updateWindowDimensions);
                var dataToSendForEligibilityOffer = {
                    "baseOfferId": this.props.cache.currentPlanDetails.planId || "",
                    "header": headers
                }
                Network.executeAxios("fetchEligibilityOffers", "POST", dataToSendForEligibilityOffer, (response) => {
                  
                    Network.executeAxios("fetchAddons", "POST", {"pog": this.props.cache.serviceInfo.pog,  "header": headers} , (addonResponse) => {
                    var finalAllAddonDetails = [];
                    if (response && response[0]) {
                        finalAllAddonDetails = response;
                    }
                    else {
                        finalAllAddonDetails = []
                    }
    
                    for (var i = 0; i < finalAllAddonDetails.length; i++) {
                        if (finalAllAddonDetails[i].success) {
                            for (var x = 0; x < finalAllAddonDetails[i].success.length; x++) {
                                this.state.addonArray.push(finalAllAddonDetails[i].success[x]);
                            }
                        }
                    }
                   
                    if (Object.keys(this.props.registerDetails.customize.addons).length == 0) {
                        this.props.setRegisterDetails("customize.addons", []);
                    } else {
                        this.setState({customizeDetails:this.props.registerDetails.customize})
                    }
            
                    this.initializeAlladdonDetails(finalAllAddonDetails, addonResponse, ignoredPlanArr);
                    
                })
            });
    }

    initializeAlladdonDetails(receivedResponse, stdAddonResponse, ignoredPlanArr) {
        var stdAddonArr = []
        for (var p = 0; p < stdAddonResponse.length; p++) {
            if (stdAddonResponse[p].success) {
                for (var q = 0; q < stdAddonResponse[p].success.length; q++) {
                    stdAddonArr.push(stdAddonResponse[p].success[q]);
                }
            }
        }
    
        var eligibilityOffers = [];
        try {
            if (Array.isArray(receivedResponse)) {
                for (var x = 0; x < receivedResponse.length; x++) {
                    if(receivedResponse[x] && receivedResponse[x].eligibilityOffers && receivedResponse[x].eligibilityOffers[0])
                    eligibilityOffers.push(receivedResponse[x].eligibilityOffers)
                }
            }
        } catch (err) {
            eligibilityOffers = [];
        }

        var finaleligibilityOffers = [];
        if(eligibilityOffers && eligibilityOffers.length > 0)
        finaleligibilityOffers = eligibilityOffers.reduce((r, e) => (r.push(...e), r), []);
      
        var finalProductOfferingsArray = [];
        for (var i = 0; i < finaleligibilityOffers.length; i++) {
            var productOfferingsArray = [];
            try {
                if (finaleligibilityOffers[i].productOfferings) {
                    if (finaleligibilityOffers[i].maxQuantity) {
                        var productOfferingsArrayNew = finaleligibilityOffers[i].productOfferings;
                        if (productOfferingsArrayNew.length > 0) {
                            for (var j = 0; j < productOfferingsArrayNew.length; j++) {
                                productOfferingsArrayNew[j].eligibilityType = finaleligibilityOffers[i].eligibilityType.id;
                            }
                        } else {
                            console.log("productOfferingsArrayNew length 0")
                        }
                    }
                    if(finaleligibilityOffers[i].productOfferings){
                    productOfferingsArray.push(finaleligibilityOffers[i].productOfferings);
                    var productOfferingsArrayUpdated = productOfferingsArray.reduce((r, e) => (r.push(...e), r), []);
                    var maxQuantity = "100000000000000"
                    if(finaleligibilityOffers[i].maxQuantity){
                        maxQuantity = finaleligibilityOffers[i].maxQuantity
                    }

                     let temp = {
                         "groupMaxQuantity" : maxQuantity,
                         "groupMinQuantity" : finaleligibilityOffers[i].minQuantity,
                         "productOfferings" : productOfferingsArrayUpdated
                     }
                     finalProductOfferingsArray.push(temp)
                    }
                }
            }
            catch (err) { }
        }

        if(stdAddonArr.length > 0) {
            let tempObj = {
                "groupMaxQuantity" : "1000000000000000",
                "groupMinQuantity" : "0",
                "productOfferings" : stdAddonArr
            }
            finalProductOfferingsArray.push(tempObj)
        }
    
        console.log("finalProductOfferingsArray",finalProductOfferingsArray)
                  
        this.setState({ignorePlanIds:ignoredPlanArr, allAddonDetails: finalProductOfferingsArray, isLoading: false });
    }

    countPlusButtonClicked(receivedData,maxCount,allAddonDetail) {
        var allAddonids =[];
        var groupMaxQuantity = allAddonDetail.groupMaxQuantity
            for(var j=0;j<allAddonDetail.productOfferings.length;j++){
                var currentProductOffering =allAddonDetail.productOfferings[j];
                allAddonids.push(currentProductOffering.id);
            }
           
            var maxcountAlowed = 0
                for (var k = 0; k < this.state.customizeDetails.devices.length; k++) {
                    if(allAddonids.includes(this.state.customizeDetails.devices[k].id)){
                        if(parseInt(this.state.customizeDetails.devices[k].count)){
                            maxcountAlowed = maxcountAlowed + (parseInt(this.state.customizeDetails.devices[k].count))
                        }
                    }
                }
             
                if(parseInt(groupMaxQuantity) > parseInt(maxcountAlowed)){
                    var temp = [];
                    Object.assign(temp, this.state.customizeDetails.devices);
                    for (var i = 0; i < temp.length; i++) {
                        if( temp[i].count  < maxCount && temp[i].id === receivedData) {
                             temp[i].count = parseInt(temp[i].count) + 1
                        }
                    }
                    this.state.customizeDetails.devices = temp;
                    this.props.setRegisterDetails("customize.devices", this.state.customizeDetails.devices);
                } else {
                    Swal.fire(this.props.locales.canNotChooseThisQuantityInAddonSelection, "", "");
                }
        this.setState({ "dummy": "dummy" })
    }

    selectAddonClickedForAddon(receivedData, minCount, allAddonDetail) {
        this.state.customizeDetails.addons=[]
        receivedData = JSON.parse(decodeURIComponent(receivedData))
        var allAddonids = [];
        var groupMaxQuantity = allAddonDetail.groupMaxQuantity
        for (var j = 0; j < allAddonDetail.productOfferings.length; j++) {
            var currentProductOffering = allAddonDetail.productOfferings[j];
            allAddonids.push(currentProductOffering.id);
        }
        var maxcountAlowed = 0
        for (var k = 0; k < this.state.customizeDetails.addons.length; k++) {
            if (allAddonids.includes(this.state.customizeDetails.addons[k].id)) {
                maxcountAlowed = parseInt(maxcountAlowed) + (parseInt(this.state.customizeDetails.addons[k].count))
            }
        }
        if (parseInt(groupMaxQuantity) > parseInt(maxcountAlowed)) {
            if (parseInt(minCount) > 0) {
                receivedData["count"] = minCount;
            } else {
                receivedData["count"] = 1;
            }
            receivedData["showCustomizeButton"] = true;
            this.state.customizeDetails.addons.push(receivedData);
            this.props.setRegisterDetails("customize.addons", this.state.customizeDetails.addons);
            this.setState({ showCustomizeButton: true });
        } else {
            Swal.fire(this.props.locales.canNotChooseThisQuantityInAddonSelection);
        }

    }

    countPlusButtonClickedForAddon(receivedData, maxCount, allAddonDetail,event) {
        event.stopPropagation();
        var allAddonids = [];
        var groupMaxQuantity = allAddonDetail.groupMaxQuantity
        for (var j = 0; j < allAddonDetail.productOfferings.length; j++) {
            var currentProductOffering = allAddonDetail.productOfferings[j];
            allAddonids.push(currentProductOffering.id);
        }
        var maxcountAlowed = 0
        for (var k = 0; k < this.state.customizeDetails.addons.length; k++) {
            if (allAddonids.includes(this.state.customizeDetails.addons[k].id)) {
                maxcountAlowed = parseInt(maxcountAlowed) + (parseInt(this.state.customizeDetails.addons[k].count))
            }
        }

        if (parseInt(groupMaxQuantity) > parseInt(maxcountAlowed)) {
            var temp = [];
            Object.assign(temp, this.state.customizeDetails.addons);
            for (var i = 0; i < temp.length; i++) {
                if (temp[i].count < maxCount && temp[i].id == receivedData) {
                    temp[i].count = parseInt(temp[i].count) + 1
                }
            }
            this.state.customizeDetails.addons = temp;
            this.props.setRegisterDetails("customize.addons", this.state.customizeDetails.addons);
        } else {
           
        }

        this.setState({ "dummy": "dummy" })
    }

    countMinusButtonClickedForAddon(receivedData, allAddonDetail,event) {
        event.stopPropagation();
        var temp = [];
        Object.assign(temp, this.state.customizeDetails.addons);
        for (var i = 0; i < temp.length; i++) {
            if (temp[i].count > 1) {
                if (temp[i].id == receivedData) {
                    temp[i].count = temp[i].count - 1
                }
            }
        }
        this.state.customizeDetails.addons = temp;
        this.props.setRegisterDetails("customize.addons", this.state.customizeDetails.addons);
        this.setState({ "dummy": "dummy" })
    }

    removeAddonClickedForAddon(receivedData, allAddonDetail) {
        try {
            var addonIndexToBeRemoved = "";
            var temp = []
            Object.assign(temp, this.state.customizeDetails.addons);
            for (var i = 0; i < temp.length; i++) {
                if (temp[i].id == receivedData) {
                    addonIndexToBeRemoved = i;
                }
            }
            temp.splice(addonIndexToBeRemoved, 1);
            this.state.customizeDetails.addons = temp;
            this.props.setRegisterDetails("customize.addons", this.state.customizeDetails.addons);
            this.state.showCustomizeButton = false;
            this.setState({ "dummy": "dummy" });
        }
        catch (err) {
            receivedData = []
        }
    }


    populateAllAddons() {
        var isAddonPresent = false;
        const allAddonDetails = this.state.allAddonDetails.map((itemArray, keyCheck) => {
            var currentItemArray = itemArray.productOfferings;
            return currentItemArray.map((item, key) => {
            try{
            var productPrice = {}
            if (item.productOfferingPrice[0]) {
                for (var i = 0; i < item.productOfferingPrice.length; i++) {
                    if(item.productOfferingPrice[i] && item.productOfferingPrice[i].priceCategory){
                        if (item.productOfferingPrice[i].priceCategory.id === "0") {
                            productPrice = item.productOfferingPrice[i];
                        }
                    }
                    
                }
            }
        

    // For discounts 
    var discountArray		= [];
    var taxArray = [];   
    var totalDiscountPrice = "0";
    var tierBasedAddonPrice = 0;
    var addonCount = 1;
    for(var e = 0; e < item.productOfferingPrice.length; e++){
        var priceObject	= item.productOfferingPrice[e];


         //tier based price
         if(priceObject && priceObject.priceCategory && priceObject.priceCategory.id && (priceObject.priceCategory.id === "0" || priceObject.priceCategory.id === "12")){
                if(priceObject && priceObject.tierbased && priceObject.tierbased == true){
                    for(var c=0; c< this.state.currentAddonList.length; c++){
                        if(item.id === this.state.currentAddonList[c]){
                            addonCount = addonCount + 1;
                        }
                    }

                    for (var i = 0; i < this.state.customizeDetails.addons.length; i++) {
                        if (item["id"] == this.state.customizeDetails.addons[i].id) {
                            var count = this.state.customizeDetails.addons[i].count;
                            if(parseInt(count) > 1){
                                addonCount = parseInt(addonCount) + (parseInt(count))
                            }
                        }
                    }

                    for(var d=0; d< priceObject.tiers.length; d++){
                        var currentTempObj = priceObject.tiers[d];
                        if(addonCount >= currentTempObj.startRange && addonCount <= currentTempObj.endRange){
                            tierBasedAddonPrice = currentTempObj.price;   
                            break;   
                        } else {
                            tierBasedAddonPrice = priceObject.price;
                        }
                    }
                } else {
                    tierBasedAddonPrice = priceObject.price;
                }
            }
        }


            var totalAddOnTaxPrice = 0;
            for(var i = 0; i < item.productOfferingPrice.length; i++){
                var priceObject	= item.productOfferingPrice[i];

                if(priceObject.priceCategory && priceObject.priceCategory.id == this.props.locales.priceCategoryForDiscount && !isNaN(parseFloat(priceObject.price))){

                    var discountPrice = "0.00";
                    
                    if(priceObject && priceObject.priceType && priceObject.priceType.id && priceObject.priceType.id == this.props.locales.PriceTypeForPercentage){
                        discountPrice = parseFloat((parseFloat(tierBasedAddonPrice).toFixed(2) * (parseFloat(priceObject.price)).toFixed(2))/100).toFixed(2);
                    } else{
                        discountPrice = (parseFloat(priceObject.price)).toFixed(2);
                    }
                    
                    totalDiscountPrice = parseFloat(totalDiscountPrice) + parseFloat(discountPrice);
                    
                    var discountObject = {
                        "discountPrice": (parseFloat(priceObject.price)).toFixed(2),
                        "discountName": priceObject.name,
                        "priceMode": priceObject.priceMode.id
                    };
                    discountArray.push(discountObject);
                }
            
                var basePriceAfterDiscount  =  parseFloat(tierBasedAddonPrice).toFixed(2) - parseFloat(totalDiscountPrice).toFixed(2);

            	//For Tax 
                var addOnTaxPrice = 0;
                var taxName = "";
                if(this.props.configurationValues){
                  taxName = this.props.configurationValues.taxName
                }

                if(priceObject && priceObject.priceCategory && priceObject.priceCategory.id && priceObject.priceCategory.id == this.props.locales.priceCategoryForTax && !isNaN(parseFloat(priceObject.price))){  
                    if(priceObject.priceType!=null && priceObject.priceType.id === this.props.locales.PriceTypeForPercentage){
                        addOnTaxPrice = (parseFloat(basePriceAfterDiscount).toFixed(2) * (parseFloat(priceObject.price)).toFixed(2)/100).toFixed(2);
                        totalAddOnTaxPrice += addOnTaxPrice
                    }else{
                        addOnTaxPrice = (parseFloat(priceObject.price)).toFixed(2);
                        totalAddOnTaxPrice += addOnTaxPrice
                    } 
                  
                    var taxObject= {
                        "taxPrice": addOnTaxPrice,
                        "taxName": taxName,
                        "priceType": priceObject.priceType.id,
                        "priceMode": priceObject.priceMode.id,
                        "tax": priceObject.price
                    };
                    taxArray.push(taxObject);  
                }
            }

          var totalAddonAmount = basePriceAfterDiscount + parseFloat(totalAddOnTaxPrice)
          totalAddonAmount = parseFloat(totalAddonAmount).toFixed(2)

            var contextValue = ""
            try {
                if (item.productOfferingPrice[0].rules[0].conditions[0]) {
                    for (var y = 0; y < item.productOfferingPrice[0].rules[0].conditions.length; y++) {
                        if (item.productOfferingPrice[0].rules[0].conditions[y].contextParam[0].name === "VideoFormat") {
                            contextValue = item.productOfferingPrice[0].rules[0].conditions[y].contextParam[0].value
                        }
                    }

                }
            } catch (err) {
                contextValue = ""
            }

            var productSubtype = {}
            try {
                if (item.productSpecifications[0]) {
                    productSubtype = item.productSpecifications[0].subType;
                }
            } catch (err) {
                productSubtype = {}
            }
            var poType = {}
            try {
                if (item.productSpecifications[0]) {
                    poType = item.productSpecifications[0].type;
                }
            } catch (err) {
                poType = {}
            }

            var productSpecifications = {}
            try {
                if (item.productSpecifications[0]) {
                    productSpecifications = item.productSpecifications[0];
                }
            } catch (err) {
                productSpecifications = {}
            }



            var productOfferGroup = {}
            try {
                if (item.productOfferGroup) {
                    productOfferGroup = item.productOfferGroup;
                }
            } catch (err) {
                productOfferGroup = {}
            }

            var connectionType = "POSTPAID"
            if(this.props.cache.currentPlanDetails.connectionType === this.props.locales.connectionTypeForPrepaid)
            {connectionType = "PREPAID"}

            // var cfss = []
            // try {
            //     if (item.productSpecifications[0].cfss) {
            //         for (var j = 0; j < item.productSpecifications[0].cfss.length; j++) {
            //             cfss.push(item.productSpecifications[0].cfss[j])
            //             delete cfss[j].validFor
            //         }
            //     }
            // } catch (err) {
            //     cfss = []
            // }

            var skipSom = "false";
            var cfss = []
            try {
               for(var m = 0; m < item.productSpecifications.length; m++){
                   var currentPS = item.productSpecifications[m];
                   for(var n = 0; n< currentPS.cfss.length; n++){
                        var currentObjCfss = currentPS.cfss[n];
                        if(currentPS.releationships.length > 0){
                            for(var o = 0; o < currentPS.releationships.length; o++){
                                var relationObj =  currentPS.releationships[0];
                                if(relationObj && relationObj.targetObject && currentObjCfss.id === relationObj.targetObject.id){
                                    if(relationObj && relationObj.skipSOM && relationObj.skipSOM == "true"){
                                        skipSom = "true";
                                    }
                                }
                            }
                        }
                        currentObjCfss["skip_som"] = skipSom
                        cfss.push(currentObjCfss)
                        delete currentObjCfss.validFor
                   }
               }
            } catch (err) {
                cfss = []
            }

            var cfssArray = []
            for (var x = 0; x < cfss.length; x++) {
                let temp = {
                    "id": cfss[x].id,
                    "name": cfss[x].name,
                    "href": cfss[x].href,
                    "service_type": cfss[x].serviceType,
                    "service_class": cfss[x].serviceClass,
                    "transport_type": cfss[x].transportType,
                    "service_category": cfss[x].serviceCategory,
                    "characteristics": cfss[x].characteristics,
                    "skip_som": cfss[x].skip_som
                }
                cfssArray.push(temp);
            }

            var isRedeemable=false;
            // for(var y=0;y<cfssArray.length;y++){
            //     if(cfssArray[y].characteristics){
            //         var characteristics=cfssArray[y].characteristics;
            //         for(var k=0;k<characteristics.length;k++){
            //             if(characteristics[k].name && characteristics[k].value){
            //                 if(characteristics[k].name=="isRedeemable" && characteristics[k].value=="true"){
            //                     isRedeemable=true;
            //                 }
            //             }
            //         }
            //     }
            // }

            var MinLoyaltyPoints="0";
            for(var y=0;y<cfssArray.length;y++){
                if(cfssArray[y].characteristics){
                    var characteristics=cfssArray[y].characteristics;
                    for(var k=0;k<characteristics.length;k++){
                        if(characteristics[k].name && characteristics[k].value){
                            if(characteristics[k].name=="MinLoyaltyPoints"){
                                MinLoyaltyPoints=characteristics[k].value
                            }
                        }
                    }
                }
            }

              //adding CFSS char value
              var cfssEndDateInYears = "2";
              if(this.props.configurationValues){
                  cfssEndDateInYears = this.props.configurationValues.cfssEndDateInYears
              }

            
            

              for (var y = 0; y < cfssArray.length; y++) {
                if (cfssArray[y].characteristics) {
                    var characteristics = cfssArray[y].characteristics;
                    for (var k = 0; k < characteristics.length; k++) {
                        if (characteristics[k].name) {
                            if(characteristics[k].name === "START_DATE"){
                                characteristics[k]["value"] =  moment().format("DD-MM-YYYY HH:mm:ss")
                            }
                            if(characteristics[k].name === "END_DATE"){
                                characteristics[k]["value"] = moment().add(cfssEndDateInYears, 'years').format("DD-MM-YYYY HH:mm:ss")
                            }
                            if(characteristics[k].name === "NAME"){
                                characteristics[k]["value"] = item.id
                            }
                        }
                    }
                }
            }

            var subscriptionCharges = []
            var effective_date = moment().format("MM/DD/YYYY HH:mm:ss")
            var expiry_date = moment().add(103, 'years').format("MM/DD/YYYY HH:mm:ss")
            if(item.ratingParameters && item.ratingParameters[0]){
                var ratingParam = item.ratingParameters[0]
                if(item.productOfferingPrice[0].priceMode.id == "1"){
                    if(ratingParam && ratingParam.subscriptionPeriod){
                        var subscriptionPeriod = parseInt(ratingParam.subscriptionPeriod)
                        if(ratingParam.subscriptionPeriodType.id == "0"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'days');
                        } else if(ratingParam.subscriptionPeriodType.id === "1"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'weeks');
                        } else if(ratingParam.subscriptionPeriodType.id === "2"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'months');
                        } else if(ratingParam.subscriptionPeriodType.id === "3"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'years');
                        } else if(ratingParam.subscriptionPeriodType.id === "4"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'hours');
                        }
                    }
                }
            }

            expiry_date = moment(expiry_date).format("MM/DD/YYYY HH:mm:ss") 
            for (var k = 0; k < item.productOfferingPrice.length; k++) {
                var prorata_flags = ""
                try {
                    var prorataEnabledInSuspension = item.productOfferingPrice[k].prorataEnabledInSuspension ? "1" : "0";
                    var prorataEnabledInTermination = item.productOfferingPrice[k].prorataEnabledInTermination ? "1" : "0";
                    var prorataEnabledInPlanChange = item.productOfferingPrice[k].prorataEnabledInPlanChange ? "1" : "0";
                    var prorataEnabledInActivation = item.productOfferingPrice[k].prorataEnabledInActivation ? "1" : "0";
                    prorata_flags = prorataEnabledInActivation + prorataEnabledInTermination + prorataEnabledInSuspension + prorataEnabledInPlanChange
                } catch (err) {
                    prorata_flags = ""
                }
                var factor = ""
                if (item.productOfferingPrice[k].factor) {
                    factor = item.productOfferingPrice[k].factor
                }
                var frequency = ""
                if (item.productOfferingPrice[k].frequency) {
                    frequency = item.productOfferingPrice[k].frequency.id
                }

                let tempCharges = {}
                try {
                    tempCharges = {
                        "upc_charge_id": item.productOfferingPrice[k].id,
                        "charge_type": item.productOfferingPrice[k].priceMode.id,
                        "charge_name": item.productOfferingPrice[k].name,
                        "charge_desc": item.productOfferingPrice[k].description,
                        "start_date": moment().format("MM/DD/YYYY HH:mm:ss"),
                        "end_date": expiry_date,
                        "charge_tax": item.productOfferingPrice[k].priceCode.taxCategoryId,
                        "charge_validity": "",
                        "charge_category": item.productOfferingPrice[k].priceCategory.billingChargeType.id,
                        "charge_id": item.id,
                        "discount_type": item.productOfferingPrice[k].priceType.name,
                        "epc_enabled": "1",
                        "quantity_based": "",
                        "charge_classification": "",
                        "charge_amount_type": item.productOfferingPrice[k].priceType.name,
                        "charge_frequency": frequency,
                        "charge_factor": factor,
                        "is_prorata": item.productOfferingPrice[k].prorataEnable ? "1" : "0",
                        "prorata_flags": prorata_flags,
                        "charge_code": item.productOfferingPrice[k].priceCode.id
                    }
                    // if(connectionType === "POSTPAID"){
                        tempCharges["charge_amount"] = item.productOfferingPrice[k].price
                        tempCharges["total_charge"] = item.productOfferingPrice[k].price
                    // } else {
                    //     tempCharges["charge_amount"] = "0"
                    //     tempCharges["total_charge"] = "0"
                    // }
                } catch (err) {
                    tempCharges = {}
                }
                subscriptionCharges.push(tempCharges)
            }

            var pogIdFromResponse = item.productOfferGroup.id;
            var productFamilyIdFromResponse = item.productOfferGroup.productFamily.id
           
            var currentAddonDataTemp = {};
            currentAddonDataTemp["id"] = item["id"];
            currentAddonDataTemp["name"] = item["marketingDescription"];
            currentAddonDataTemp["description"] = item["description"] || "NA";
            currentAddonDataTemp["offerAmount"] = tierBasedAddonPrice;
            currentAddonDataTemp["addonPriceWithDiscount"] = totalAddonAmount;
            currentAddonDataTemp["effective_date"] = effective_date;
            currentAddonDataTemp["expiry_date"] = expiry_date;
            currentAddonDataTemp["productId"] = productOfferGroup.id;
            currentAddonDataTemp["productName"] = productOfferGroup.name;
            currentAddonDataTemp["poType"] = poType.id;
            currentAddonDataTemp["subscriptionCharges"] = subscriptionCharges;
            currentAddonDataTemp["contextValue"] = contextValue;
            currentAddonDataTemp["pogIdFromResponse"] = pogIdFromResponse;
            currentAddonDataTemp["eligibilityType"] = item.eligibilityType || 0;
            currentAddonDataTemp["productFamilyIdFromResponse"] = productFamilyIdFromResponse;
            currentAddonDataTemp["isRedeemable"] = isRedeemable;
            currentAddonDataTemp["MinLoyaltyPoints"] = MinLoyaltyPoints;
            currentAddonDataTemp["connectionType"] = connectionType;
            currentAddonDataTemp["discountArray"] = discountArray;
            currentAddonDataTemp["taxArray"] = taxArray;
            if (cfssArray.length > 0) {
                currentAddonDataTemp["cfss"] = cfssArray;
            }
            if(productSpecifications && productSpecifications.subType && productSpecifications.subType.id)
            currentAddonDataTemp["po_sub_type"] = productSpecifications.subType.id || 0;

            if(productSubtype && productSubtype.id)
            currentAddonDataTemp["productSubtype"] = productSubtype.id || 0;
        }
            catch(err){
                currentAddonDataTemp = {}
            }
            var currentAddonData = encodeURIComponent(JSON.stringify(currentAddonDataTemp));
          
            var isSelected = false;
            for (var l = 0; l < this.state.customizeDetails.addons.length; l++) {
                if (item["id"] === this.state.customizeDetails.addons[l].id) {
                    isSelected = true
                }
            }

            var isFnfAddonPresent = "false"
            if(item.ratingParameters && item.ratingParameters[0]){
                isFnfAddonPresent = item.ratingParameters[0].friendsAndFamily;
            }

            var isSelected = false;
            for (var i = 0; i < this.state.customizeDetails.addons.length; i++) {
                if (item["id"] == this.state.customizeDetails.addons[i].id) {
                    isSelected = true
                    var count = this.state.customizeDetails.addons[i].count;
                    var id = this.state.customizeDetails.addons[i].id;
                }
            }

            var maxQuantity = "1"
            if(item.maxQuantity){
                maxQuantity = item.maxQuantity
            }

            var minQuantity = "0"
            if(item && item.minQuantity){
                minQuantity = item.minQuantity
            }

            if(this.state.activeAddonIds.includes(item.id) || this.state.ignorePlanIds.includes(item.marketingDescription)){

            } 
            else if(isFnfAddonPresent !== "true" ){
            isAddonPresent = true;
            return (
                <div className="col-md-6 p-0" key={key}>
                <div className={isSelected ? "allAddonDetailForAddonInactive activeAddoncard align-items-center mb-3 row m-0" : "allAddonDetailForAddonInactive align-items-center mb-3 row m-0" }
                    onClick={() => isSelected ? this.removeAddonClickedForAddon(item.id, itemArray) : this.selectAddonClickedForAddon(currentAddonData, minQuantity, itemArray) } >
                <div className='col-md-12 py-4' style={{minHeight: 197}}>
                  
                <div className="col-12 row p-0 px-2 m-0 pt-2 justify-content-between">
                    <div className="nameContainer col-9 p-0">{item.marketingDescription}</div>
                        <div className="col-3 row m-0 p-0 justify-content-end">
                            {maxQuantity === "1" || maxQuantity === minQuantity
                                ?
                                null 
                            :
                            <div className="col-md-12 row p-0 m-0">
                            { isSelected
                                ?
                                    <div className="row p-0 m-0 pb-2">
                                        <div className="input-group" style={{ width: '80%', height: 25, marginLeft: 'auto' }}>
                                            <div className="input-group-prepend" style={{ marginRight: 0 }}>
                                                <span className="input-group-text" style={{ marginTop: 9, height: 18, padding: '0px 5px', cursor: 'pointer', borderRadius: '50%', border: '1px solid #404142' }} onClick={(event) => { this.countMinusButtonClickedForAddon(item.id, itemArray,event) }}>
                                                    <FaMinus style={{ fontSize: 8, height: 12 }} />
                                                </span>
                                            </div>
                                            <input type="text" className="form-control" style={{ fontWeight: 700, border: 0, fontSize: 13, padding: 0, textAlign: 'center' }} value={count} />
                                            <div className="input-group-append" style={{ marginLeft: 0 }}>
                                                <span className="input-group-text" style={{ marginTop: 9, height: 18, padding: '0px 5px', cursor: 'pointer', borderRadius: '50%', border: '1px solid #404142' }} onClick={(event) => { this.countPlusButtonClickedForAddon(id, maxQuantity, itemArray,event) }}>
                                                    <FaPlus style={{ fontSize: 8, height: 12 }} />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    null
                                }
                            </div>
                            }
                            <div className="row p-0 m-0 amountVal">
                                {/* ${tierBasedAddonPrice} */}
                            </div>
                            {/* <div className="nameContainerDesc">(Base Price)</div> */}
                        </div>
                    </div>
                    <div className="col-md-12 row p-0 px-2 m-0 pb-2">
                        <div className="nameContainerDesc">{item.description}</div>
                    </div>

                        {discountArray.map((item, key) => {
                                return (
                                    <div className='col-12 d-flex justify-content-between align-items-center p-0 px-2 pb-2' key={key} style={{fontWeight: 600, color: '#FE9A2E'}}>
                                        <div>
                                            <div className="amountName">{item.discountName}</div>
                                        </div>
                                        <div>
                                            <div className="amountVal">${item.discountPrice}</div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        
                        {/* {taxArray.map((item, key) => {
                                return (
                                    <div className='col-12 d-flex justify-content-between align-items-center p-0 px-2 pb-2' key={key} style={{fontWeight: 600}}>
                                        <div>
                                            <div className="amountName">{item.taxName}</div>
                                        </div>
                                        <div>
                                            <div className="amountVal">${item.taxPrice}</div>
                                        </div>
                                    </div>
                                )
                            })
                        } */}
                    </div>
                    <div className='col-12 d-flex justify-content-end align-items-center totalPriceContainer'>
                        <div className='name px-3'>
                            Total
                        </div>
                        <div className='price'>
                            ${totalAddonAmount}
                        </div>
                    </div>
                </div>
            </div>
            );
            }
        });
    })

        if (isAddonPresent) {
             return (<div className="allAddonDetailContainer row col-md-12 p-0 mx-auto">{allAddonDetails}</div>);
        } else {
            return (<div className="allAddonDetailContainer row m-0 col-md-12 p-0 mx-auto"><div className="col-md-12 mx-auto mt-3 row p-0"><NoDataFound content="No add-ons are available" /></div></div>);
        }
    }

    arrowButtonClicked(type){
        this.setState({isCartVisibleForMobile:type})
    }

    cartNextButtonClicked = (type) => {
        if(type === "back"){
            this.setState({isConfirmationPageVisible: false})
        } else {
            this.setState({isConfirmationPageVisible: true})
        }
       
    }



    render() {
        return (
            <div className="col-md-12 animated fadeIn justify-content-center p-0 m-0">
                <div id="RechargeComponentContainer">
                    {this.state.isLoading  === true ? <LoadingAnimation isVisible={true} /> : null}
                    {this.state.isConfirmationPageVisible ? <AddonConfirmationPart callBack={this.cartNextButtonClicked}/> : this.componentContent()}
                </div>
            </div>
        );
    }

    componentContent() {
        if(this.state.isCartVisibleForMobile == false){
            const customizeComponentStyle = { minHeight: this.state.windowHeight + 'px' ,width:'92%'};
            return (
                <div className="mb-5">
                <div className="col-md-12 p-0 ml-auto" style={customizeComponentStyle}>
                    <div className="col-md-12 row changePlanCustomizePart m-0 p-0">
                        <div className="col-md-8 pb-4 p-0 pr-3">
                            <div className="col-md-12 p-0">
                                <div className="col-md-12 p-0 pr-3"><div className="col-md-12 pb-2 p-0 mb-4 mt-sm-0 mt-4 chooseAddonHead" style={{borderBottom:'1px solid #D6D6D6'}}>{this.props.locales.chooseAddonsForAllAddonsComponent}</div></div>
                                <div className="col-md-12 pb-4 pr-0 p-0">
                                    <div className="addonDetailsContainer col-md-12 p-0 m-0">
                                        <div className="col-md-12 row p-0 m-0">{this.populateAllAddons()}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4  pb-4 d-none d-sm-block">
                                <PlanCartComponent callBack={this.cartNextButtonClicked}/>
                        </div>
    
                    </div>
                    </div>
    
              {Object.keys(this.props.registerDetails.customize.addons).length > 0 ?
                <div className="d-block d-md-none bottomCartPartForMobile" style={{bottom:0}}>
                    <div className="d-flex flex-column">
                        <div className="d-flex justify-content-center pt-2"><img src={PathIcon} alt="" onClick={() => { this.arrowButtonClicked(true) }}/></div>
                        <div className="d-flex align-items-center justify-content-between px-3 pb-1">
                            <div className="amountContainer">
                                    <div>{this.props.locales.amountToPayForMobViewAllAddons}</div>
                                    <div style={{fontSize: 28}}>{Constants.dollarSign}{GeneralUtils.formatNumberToStandardForm(this.state.totalMonthlyCharges,this.props.configurationValues)}</div>
                            </div>
                            <div>
                            <div className="blueButtonContainer" onClick={() => { this.cartNextButtonClicked() }}>
                               {this.props.locales.nextBtnTxtMobViewAllAddonsComponent}
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                : null }

                </div>
            );
        } else {
            const customizeComponentStyle = { minHeight: this.state.windowHeight + 'px' ,width:'100%', marginTop: '110px'};
            return(
            <div className="mb-5 mx-4 col-12 mx-auto">
            <div className="col-12 p-0" style={customizeComponentStyle}>
                <div className="col-12  pb-4 m-0 mx-auto px-0">
                    <PlanCartComponent callBack={this.cartNextButtonClicked}/>
                </div>
            </div>
            {Object.keys(this.props.registerDetails.customize.addons).length > 0 ?
                <div className="d-block d-md-none bottomCartPartForMobile" style={{top:0}}>
                <div className="d-flex flex-column">
                    <div className="d-flex align-items-center justify-content-between px-3 pt-1">
                        <div className="amountContainer">
                                <div>{this.props.locales.amountToPayForMobViewAllAddons}</div>
                                <div style={{fontSize: 28}}>{Constants.dollarSign}{GeneralUtils.formatNumberToStandardForm(this.state.totalMonthlyCharges,this.props.configurationValues)}</div>
                        </div>
                        <div>
                        <Button className="nextButton" onClick={() => { this.cartNextButtonClicked() }}>
                            {this.props.locales.nextBtnTxtMobViewAllAddonsComponent}
                        </Button>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center pb-2"><img className="rotate180" src={PathIcon} alt="" onClick={() => { this.arrowButtonClicked(false) }} /></div>
                </div>
            </div>
        : null }

            </div>
        );
        }
    }
}


const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache,
        userDetails: state.userDetails,
        configurationValues: state.configurationValues,
        registerDetails: state.registerDetails
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setCache: function (key, payload) {
            dispatch(setCache(key, payload));
        },
        setRegisterDetails: function (key, payload) {
            dispatch(setRegisterDetails(key, payload));
        }
    }
}

const RechargeComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(RechargeComponent)

export default RechargeComponentContainer;
